import React, { Component } from "react";
import {observer, inject} from 'mobx-react';
import Flexbox from 'flexbox-react';
import LiveOrderStreamPanelHeader from './live_order_stream_panel_header';
import LiveOrderStreamWidgetHeader from "../order_stream_widget/live_order_stream_widget_header";
import OrderStreamWidgetAlert from '../alerts/order_stream_widget_alert';
import {
  UNDER_MAINTENANCE_FLAG,
  CONNECTION_ISSUE_FLAG,
  SHOP_CLOSED_WITH_ORDERS_FLAG
} from '../../constants';
import {observable} from "mobx";

function newDisplayHeader(displayHeaderFlag) {
  if([CONNECTION_ISSUE_FLAG, UNDER_MAINTENANCE_FLAG, SHOP_CLOSED_WITH_ORDERS_FLAG].includes(displayHeaderFlag)) {
    return <OrderStreamWidgetAlert alertString={displayHeaderFlag}/>;
  } else {
    return;
  }
}


@inject('RootStore')
@observer
export default class LiveOrderStreamPanel extends Component {
  @observable orderStreamPanelHeaderContainerHeight = 0

  constructor(props) {
    super(props);
    this.orderStreamPanelHeaderContainer = React.createRef()
  }

  componentDidMount() {
    this.orderStreamPanelHeaderContainerHeight = this.orderStreamPanelHeaderContainer.current.clientHeight
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    this.orderStreamPanelHeaderContainerHeight = this.orderStreamPanelHeaderContainer.current.clientHeight
  }

  render() {
        const {styleStore, configStore} = this.props.RootStore
        const headerSplitterStyle = {
          "borderTop": styleStore.currentStylesDict.headerLineSplitStyle,
          "margin": "auto",
          "marginBottom": '0.5em'
        };
        const widgetHeaderStyle = {
          marginTop: styleStore.currentLiveStreamOrderStyle.widgetHeaderMarginTop
        }
        const {orderDisplayHeader, isShopOpen, isAlertShown, displayAlert} = configStore;
        const isDisplayConnectionIssue = displayAlert === CONNECTION_ISSUE_FLAG
        const displayHeader = newDisplayHeader(orderDisplayHeader);
        const liveOrderStreamFontSize = {fontSize: styleStore.currentLiveStreamOrderStyle.widgetFontSize};
        return (
            <Flexbox height="100%" width={'87%'} style={liveOrderStreamFontSize}
                     flexDirection="column" alignItems="center">
              <div style={{height: styleStore.currentLiveStreamOrderStyle.panelHeaderHeight, width: "100%"}} ref={this.orderStreamPanelHeaderContainer}>
                <LiveOrderStreamPanelHeader parentContainerHeight={this.orderStreamPanelHeaderContainerHeight}/>
              </div>
              <Flexbox height={styleStore.currentLiveStreamOrderStyle.panelHeaderSplitLineHeight} width="100%" style={headerSplitterStyle}></Flexbox>
              {isAlertShown &&
                <Flexbox height={styleStore.currentLiveStreamOrderStyle.alertHeight} width="100%">
                  {displayHeader}
                </Flexbox>
              }
              {isShopOpen &&
                <Flexbox width="100%" height={styleStore.currentLiveStreamOrderStyle.widgetHeaderHeight}
                         style={{...widgetHeaderStyle, "visibility": isDisplayConnectionIssue ? "hidden" : "visible"}}>
                  <LiveOrderStreamWidgetHeader/>
                </Flexbox>}
            </Flexbox>
      )
    }
}



// WEBPACK FOOTER //
// ./src/components/live_order_stream_panel/live_order_stream_panel.jsx